"use strict";
var React = require('react');
var react_dom_1 = require('react-dom');
var store_1 = require('./containers/store');
react_dom_1.render(React.createElement(store_1.default, null), document.getElementById('app'));



/*****************
 ** WEBPACK FOOTER
 ** ./src/app.tsx
 ** module id = 0
 ** module chunks = 0
 **/